// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__dESvB","addWidgetButton":"Header_addWidgetButton__1x4XL","dashboardTabs":"Header_dashboardTabs__3xQfs","active":"Header_active__AuoDS"};